import { useTranslation } from 'react-i18next'
import { useBank, useAccountType } from '@/features/Pad'

import {
  ContentWrapper,
  AreaTitle,
  StyledPanel,
  StyledRow,
  StyledLabel,
  StyledValue
} from './elements'

type FinancialAccountInfoProps = {
  financialInstitutionName: string
  accountType: string
  accountNumber: string
}

const FinancialAccountInfo: React.FC<FinancialAccountInfoProps> = ({
  financialInstitutionName,
  accountType,
  accountNumber
}) => {
  const { t } = useTranslation()
  const bankName = useBank(financialInstitutionName)
  const account = useAccountType(accountType)

  return (
    <ContentWrapper>
      <AreaTitle>
        {t('b.payment.view.financial_account_information.title', 'Financial Account Information')}
      </AreaTitle>
      <StyledPanel hSpace={24} vSpace={24}>
        <StyledRow bottom={20}>
          <StyledLabel>
            {t('b.payment.view.financial_institution.label', 'Financial Institution')}
          </StyledLabel>
          <StyledValue>{bankName}</StyledValue>
        </StyledRow>
        <StyledRow bottom={20}>
          <StyledLabel>{t('b.payment.view.account_type.label', 'Account Type')}</StyledLabel>
          <StyledValue>{account}</StyledValue>
        </StyledRow>
        <StyledRow>
          <StyledLabel>{t('b.payment.view.account_number.label', 'Account Number')}</StyledLabel>
          <StyledValue>{accountNumber}</StyledValue>
        </StyledRow>
      </StyledPanel>
    </ContentWrapper>
  )
}

export default FinancialAccountInfo
